export default "__VITE_ASSET__BZ0D_yQP__"